import { log } from 'log';
import { path } from 'ramda';
import { useUpdateEffect } from 'js/hooks/useUpdateEffect';
import { useCookieSettingsSelector } from 'js/store/hooks';

export const useSportsbookCookie = () => {
    const statisticsCookie = useCookieSettingsSelector(path(['groupsData', 'statistics']));

    useUpdateEffect(() => {
        if (!window.Sportsbook) {
            return;
        }

        try {
            window.Sportsbook.sendMessage('GIVE_COOKIE_CONSENT', { analytics: statisticsCookie });
        } catch (error) {
            log('log', '[SPORTSBOOK | Portal] Get balance error', error);
        }
    }, [statisticsCookie]);
};
